import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './components/Home';
import * as Lessons from './lessons';
import logo from './assets/Urbanwebhost-Logo_w.svg';
import blackLogo from './assets/Urbanwebhost-Logo_b.svg';

function App() {
  useEffect(() => {
    console.log("🎓 React Teaching App Loaded");
    console.log("💡 TIP: Keep the console open to see detailed logs for each lesson!");
    console.log("📚 Total Lessons: 20");
  }, []);

  return (
    <BrowserRouter>
      <Navigation />
      <div className="container mt-4 mb-5">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lesson1" element={<Lessons.Lesson01 />} />
          <Route path="/lesson2" element={<Lessons.Lesson02 />} />
          <Route path="/lesson3" element={<Lessons.Lesson03 />} />
          <Route path="/lesson4" element={<Lessons.Lesson04 />} />
          <Route path="/lesson5" element={<Lessons.Lesson05 />} />
          <Route path="/lesson6" element={<Lessons.Lesson06 />} />
          <Route path="/lesson7" element={<Lessons.Lesson07 />} />
          <Route path="/lesson8" element={<Lessons.Lesson08 />} />
          <Route path="/lesson9" element={<Lessons.Lesson09 />} />
          <Route path="/lesson10" element={<Lessons.Lesson10 />} />
          <Route path="/lesson11" element={<Lessons.Lesson11 />} />
          <Route path="/lesson12" element={<Lessons.Lesson12 />} />
          <Route path="/lesson13" element={<Lessons.Lesson13 />} />
          <Route path="/lesson14" element={<Lessons.Lesson14 />} />
          <Route path="/lesson15" element={<Lessons.Lesson15 />} />
          <Route path="/lesson16" element={<Lessons.Lesson16 />} />
          <Route path="/lesson17" element={<Lessons.Lesson17 />} />
          <Route path="/lesson18" element={<Lessons.Lesson18 />} />
          <Route path="/lesson19" element={<Lessons.Lesson19 />} />
          <Route path="/lesson20" element={<Lessons.Lesson20 />} />
        </Routes>
      </div>
      <footer className="bg-light text-center py-3 mt-5">
        <div className="container d-flex align-items-center justify-content-center gap-2">
          <img src={blackLogo} alt="Urban Web .Host" style={{height:28}} />
          <p className="mb-0 text-muted">React Easy Learning - 20 Interactive Lessons</p>
        </div>
      </footer>
    </BrowserRouter>
  );
}

export default App;
